// import * as moment from "moment";
import moment from "moment";
import * as momentTz from "moment-timezone";
// import * as _ from "lodash-es";
import {
  transform,
  isEqual,
  isObject,
} from "lodash-es";
import { Table } from "primeng/table";
import { FilterMetadata } from "primeng/api";
import { AbstractControl, FormArray, FormControl, FormGroup } from "@angular/forms";
import { ElementRef } from "@angular/core";
import { countryCodeList } from "../shared/constants/constant";

// export const EMAIL_WITH_TLD_REGEX = /^(?![^@]*\+)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.]+$/;
export const EMAIL_WITH_TLD_REGEX = /^(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9._%+-]+(?<!\.)@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/; // supports TLD
export const EMAIL_WITH_NO_TLD_REGEX = /^(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9._%+-]+(?<!\.)@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/; // doesn't support TLD


// export const URL_REGEX = /^(http|https):\/\/[^ "]+$/;
export const URL_REGEX = /(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})[\/\w .-]*\/?/
export const FULL_URL_REGEX = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s#?]+)?(\?[^#\s]+)?(#\S+)?$/


export const DEFAULT_TIMEZONE_MOMENT = "America/Los_Angeles";




export function getDateValueFormatted(givenDate: any) {
  let changedDate: any = null;
  if (!givenDate) {
    changedDate = null;
  }
  if (typeof givenDate === "string") {
    changedDate = givenDate;
  }
  if (givenDate instanceof Date) {
    changedDate = moment(givenDate).format("YYYY-MM-DD");
  }
  try {
    const mom = moment(givenDate);
    if (mom.isValid()) {
      changedDate = mom.format("YYYY-MM-DD");
    }
    else {
      changedDate = null;
    }
  } catch (e) {
    changedDate = null;
  }
  if (changedDate === "Invalid date") {
    changedDate = null;
  }

  console.table({
    givenDate,
    changedDate,
    changedDateType: typeof changedDate,
    changedDateInstance: changedDate instanceof Date,
  });

  return changedDate;
  // // assuming date is already in string format
  // return date;
}




export async function wait(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


export function getLADateTimeFromFormat(date: string, format: string): moment.Moment {
  // return moment.tz(date, format, DEFAULT_TIMEZONE_MOMENT);
  return momentTz.tz(date, format, DEFAULT_TIMEZONE_MOMENT);
}

export class DateHelpers {
  public static get defaultServerDateTimeFormat(): string {
    return "YYYY-MM-DD HH:mm:ss";
  }
  public static get defaultServerDateFormat(): string {
    return "YYYY-MM-DD";
  }

  public static get defaultServerTimeFormat(): string {
    return "HH:mm:ss";
  }

  public static get defaultServerTimeFormatNoSeconds(): string {
    return "HH:mm";
  }

  // local showing date time format
  public static get defaultLocalDateTimeFormat(): string {
    return "MM-DD-YYYY hh:mm:ss A";
  }

  public static get defaultLocalDateFormat(): string {
    return "MM-DD-YYYY";
  }

  // public static getLADateTimeFromFormat(date: string, format: string): moment.Moment {
  //     return moment.tz(date, format, DEFAULT_TIMEZONE_MOMENT);
  // }


}


export function getLocalDateStringFromServerDate(date: string): string {
  if (isEmpty(date)) {
    // console.log("getLocalDateStringFromServerDate", "date is empty", { input: date, output: "" });
    return "";
  }

  // const out = moment.tz(date, DateHelpers.defaultServerDateFormat, DEFAULT_TIMEZONE_MOMENT)
  //     .format(DateHelpers.defaultLocalDateFormat);
  // console.info("getLocalDateStringFromServerDate", { input: date, output: out });
  // return out;

  const out = moment(date, DateHelpers.defaultServerDateFormat).format(DateHelpers.defaultLocalDateFormat);
  console.info("getLocalDateStringFromServerDate", { input: date, output: out });
  return out;
}

export function getLocalDateFromServerDate(date: string): Date | null {
  if (isEmpty(date)) {
    // console.log("getLocalDateFromServerDate", "date is empty", { input: date, output: null });
    return null;
  }

  // const out = moment.tz(date, DateHelpers.defaultServerDateFormat, DEFAULT_TIMEZONE_MOMENT)
  //     .toDate();
  // console.info("getLocalDateFromServerData", { input: date, output: out });
  // return out;

  const mom = moment(date, DateHelpers.defaultServerDateFormat);
  let out = null;
  if (!mom.isValid()) {
    out = null;
  }
  else {
    out = mom.toDate();
  }
  console.info("getLocalDateFromServerData", { input: date, output: out });
  return out;
}


export function isEmpty(str: any): boolean {
  return (
    (str === null)
    || (str === undefined)
    || (String(str).trim() === "")
  );
}

export function getNestedErrorObject(error: any): Object {
  function extractErrorDetails(err: any): Object {
    const errorDetails: any = {
      message: err.message,
      name: err.name,
      stack: err.stack,
      ...(err.code && { code: err.code }),
      ...(err.errno && { errno: err.errno }),
      ...(err.syscall && { syscall: err.syscall }),
      ...(err.path && { path: err.path }),
      ...(err.columnNumber && { columnNumber: err.columnNumber }), // Non-standard
      ...(err.fileName && { fileName: err.fileName }), // Non-standard
      ...(err.lineNumber && { lineNumber: err.lineNumber }), // Non-standard
    };

    if (err.cause instanceof Error) {
      errorDetails.cause = extractErrorDetails(err.cause);
    }

    return errorDetails;
  }

  return extractErrorDetails(error);
}






export function toLowerCase(str: any): string {
  return String(str).toLowerCase();
}

export function toUpperCase(str: any): string {
  return String(str).toUpperCase();
}




export function objectDifference(object: any, base: any, strict = false) {
  function changes(object: any, base: any) {
    return transform(object, function (result: any, value: any, key: string) {
      // if (!isEqual(value, base[key])) {
      //     result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
      // }
      if (!compareValues(value, base[key], strict)) {
        result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
}



export function compareValues(value1: any, value2: any, strict = false) {
  if (strict) {
    return value1 === value2;
  }
  return value1 == value2;
}


export function getDateFromDateOrMoment(date: Date | moment.Moment | null | undefined): Date | null | undefined {
  // if (date instanceof Date) {
  //     return date;
  // }
  // if (moment.isMoment(date)) {
  //     return date.toDate();
  // }
  // return null;

  if (date === null) {
    return null;
  }
  if (date === undefined) {
    return undefined;
  }

  if (date instanceof Date) {
    return date;
  }
  if (moment.isMoment(date)) {
    return date.toDate();
  }

  return null;
}


export function compareDateValues(date1: Date | null | undefined, date2: Date | null | undefined): boolean {

  const date1Value = getDateFromDateOrMoment(date1);
  const date2Value = getDateFromDateOrMoment(date2);

  if (date1Value === null && date2Value === null) {
    return true;
  }
  if (date1Value === null || date2Value === null) {
    return false;
  }
  if (date1Value === undefined || date2Value === undefined) {
    return false;
  }
  // console.log('compareDateValues', {
  //   // date1Value,
  //   // date2Value,
  //   // date1ValueStr: date1Value.toISOString(),
  //   // date2ValueStr: date2Value.toISOString(),
  //   date1ValueStrDate: date1Value.toDateString(),
  //   date2ValueStrDate: date2Value.toDateString(),

  // });
  // check only date parts
  return date1Value.toDateString() === date2Value.toDateString();
}


// export function prettyDate(date?: string | Date | moment.Moment): string {
//   if (!date) return "";
//   return moment(date).format("YYYY-MM-DD");
// }

/**
 * Formats a given date to a string in the format "1st January, 2024".
 *
 * The day of the month will include an ordinal indicator (e.g., "1st", "2nd"),
 * the month will be the full name (e.g., "January"), and the year will be in four digits.
 *
 * @param date - The date to format. Can be a string, Date object, or a moment.Moment object.
 *               If no date is provided, an empty string will be returned.
 *
 * @returns A string representing the formatted date in the format "Do MMMM, YYYY".
 *          If the input date is undefined, it returns an empty string.
 *
 * @example
 * // Returns "1st January, 2024"
 * prettyDate("2024-01-01");
 *
 * @example
 * // Returns "25th December, 2024"
 * prettyDate(new Date(2024, 11, 25));
 *
 * @example
 * // Returns ""
 * prettyDate(); // No date provided
 * @author By Suvojit Modak 22-08-2024
 */
export function prettyDate(date?: string | Date | moment.Moment): string {
  if (!date) return "";
  const momentDate = moment(date);
  const day = momentDate.format("Do");
  const month = momentDate.format("MMMM");
  const year = momentDate.format("YYYY");
  return `${day} ${month}, ${year}`;
}



// export function prettyDateTime(date?: string | Date | moment.Moment): string {
//   if (!date) return "";
//   return moment(date).format("YYYY-MM-DD HH:mm:ss");
// }

/**
 * Formats a given date and time to a string in the format "1st January 2024 02:30:00 PM".
 *
 * The day of the month will include an ordinal indicator (e.g., "1st", "2nd"),
 * the month will be the full name (e.g., "January"), and the year will be in four digits.
 * The time will be displayed in a 12-hour format followed by "AM" or "PM".
 *
 * @param date - The date to format. Can be a string, Date object, or a moment.Moment object.
 *               If no date is provided, an empty string will be returned.
 *
 * @returns A string representing the formatted date and time in the format "Do MMMM YYYY hh:mm:ss A".
 *          If the input date is undefined, it returns an empty string.
 *
 * @example
 * // Returns "1st January 2024 02:30:00 PM"
 * prettyDateTime("2024-01-01T14:30:00");
 *
 * @example
 * // Returns "25th December 2024 08:00:00 AM"
 * prettyDateTime(new Date(2024, 11, 25, 8, 0, 0));
 *
 * @example
 * // Returns ""
 * prettyDateTime(); // No date provided
 * @author By Suvojit Modak 22-08-2024
 */
export function prettyDateTime(date?: string | Date | moment.Moment): string {
  if (!date) return "";
  const momentDate = moment(date);
  const day = momentDate.format("Do");
  const month = momentDate.format("MMMM");
  const year = momentDate.format("YYYY");
  const time = momentDate.format("hh:mm:ss A"); // 12-hour format with AM/PM

  return `${day} ${month}, ${year} ${time}`;
}




export const imagePlacehoderLink = (seed: any = "yippie", w: number | undefined = 200, h: number | undefined = undefined) => {
  // `https://picsum.photos/seed/picsum/90=${String(seed)}`;
  w = w || 200;
  h = h || w;
  seed = seed?.toString() || "yippie";
  return `https://picsum.photos/${w}/${h}?random=${seed}`;

};

export const STATIC_JOB_STATUSE_CODES = {
  NEW: 'NEW',
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS',
  // PARTS_UNAVAILABLE: 'PARTS_UNAVAILABLE',
  // INCORRECT_PARTS: 'INCORRECT_PARTS',
  // MACHINE_NOT_FOUND: 'MACHINE_NOT_FOUND',
  ON_HOLD: 'ON_HOLD',
  COMPLETED: 'COMPLETED',
  FINISHED: 'FINISHED'
};


export const STATIC_JOB_STATUSES = [
  {
    "code": "NEW",
    "name": "New",
    "name2": "New"
  },
  {
    "code": "ASSIGNED",
    "name": "Assigned",
    "name2": "Assigned"
  },
  {
    "code": "IN_PROGRESS",
    "name": "In Progress",
    "name2": "In Progress"
  },
  // {
  //   "code": "PARTS_UNAVAILABLE",
  //   "name": "Parts Unavailable",
  //   "name2": "On Hold (Parts Unavailable)"
  // },
  // {
  //   "code": "INCORRECT_PARTS",
  //   "name": "Incorrect Parts",
  //   "name2": "On Hold (Incorrect Parts)"
  // },
  // {
  //   "code": "MACHINE_NOT_FOUND",
  //   "name": "Machine Not Found",
  //   "name2": "On Hold (Machine Not Found)"
  // },
  {
    "code": "ON_HOLD",
    "name": "On Hold",
    "name2": "On Hold"
  },
  {
    "code": "COMPLETED",
    "name": "Completed",
    "name2": "Completed"
  },
  {
    "code": "FINISHED",
    "name": "Finished",
    "name2": "Finished"
  }
];


export const getJobStatusFiltered = (statusOrStatuses: string | string[]) => {
  const statuses = Array.isArray(statusOrStatuses) ? statusOrStatuses : [statusOrStatuses];
  return STATIC_JOB_STATUSES.filter((v) => !statuses.includes(v.code));
};

export const getJobStatusName = (status: string) => {
  const found = STATIC_JOB_STATUSES.find((v) => v.code === status);
  return found?.name || status;
}

export const getJobStatusName2 = (status: string) => {
  const found = STATIC_JOB_STATUSES.find((v) => v.code === status);
  return found?.name2 || status;
}


export const STATIC_JOB_WORK_STATUS_CODES = {
  PENDING: 'PENDING',
  TRIP_STARTED: 'TRIP_STARTED',
  TRIP_ENDED: 'TRIP_ENDED',
  JOB_STARTED: 'JOB_STARTED',
  JOB_ENDED: 'JOB_ENDED',
  JOB_PAUSED: 'JOB_PAUSED',
  JOB_RESUMED: 'JOB_RESUMED',
  JOB_ON_HOLD: 'JOB_ON_HOLD',
  JOB_FINISHED: 'JOB_FINISHED',
  RETURN_TRIP_STARTED: 'RETURN_TRIP_STARTED',
  RETURN_TRIP_ENDED: 'RETURN_TRIP_ENDED',
};


export const STATIC_JOB_WORK_STATUS = [
  {
    code: 'PENDING',
    name: 'Pending',
    name2: 'Pending'
  },
  {
    code: 'TRIP_STARTED',
    name: 'Trip Started',
    name2: 'Trip Started'
  },
  {
    code: 'TRIP_ENDED',
    name: 'Trip Ended',
    name2: 'Trip Ended'
  },
  {
    code: 'JOB_STARTED',
    name: 'Job Started',
    name2: 'Job Started'
  },
  {
    code: 'JOB_ENDED',
    name: 'Job Ended',
    name2: 'Job Ended'
  },
  {
    code: 'JOB_PAUSED',
    name: 'Job Paused',
    name2: 'Job Paused'
  },
  {
    code: 'JOB_RESUMED',
    name: 'Job Resumed',
    name2: 'Job Resumed'
  },
  {
    code: 'JOB_ON_HOLD',
    name: 'Job On Hold',
    name2: 'Job On Hold'
  },
  {
    code: 'JOB_FINISHED',
    name: 'Job Finished',
    name2: 'Job Finished'
  },
  {
    code: 'RETURN_TRIP_STARTED',
    name: 'Return Trip Started',
    name2: 'Return Trip Started'
  },
  {
    code: 'RETURN_TRIP_ENDED',
    name: 'Return Trip Ended',
    name2: 'Return Trip Ended'
  }
];


export const getJobWorkStatusName = (status: string) => {
  const found = STATIC_JOB_WORK_STATUS.find((v) => v.code === status);
  return found?.name || status;
}

export const getJobWorkStatusName2 = (status: string) => {
  const found = STATIC_JOB_WORK_STATUS.find((v) => v.code === status);
  return found?.name2 || status;
}

export const getJobWorkStatusFiltered = (statusOrStatuses: string | string[]) => {
  const statuses = Array.isArray(statusOrStatuses) ? statusOrStatuses : [statusOrStatuses];
  return STATIC_JOB_WORK_STATUS.filter((v) => !statuses.includes(v.code));
}

// this function for filter in table
export const isFilterApplied = (field: string, filtersValue: FilterMetadata | FilterMetadata[] | undefined): boolean => {
  if (!filtersValue) return false;
  if (Array.isArray(filtersValue)) {
    return filtersValue.some(filter => filter.value !== null && filter.value !== undefined && filter.value !== '');
  }
  return filtersValue.value !== null && filtersValue.value !== undefined && filtersValue.value !== '';
}

export const doesColumnHaveFilter = (table: Table, field: string): boolean => {
  return isFilterApplied(field, table.filters[field]);
}

export const mapFiltersToObject = (table: Table): { [key: string]: any } => {
  let filtersObj: { [key: string]: any } = {};
  for (const [key, value] of Object.entries(table.filters)) {
    if (isFilterApplied(key, value)) {
      filtersObj[key] = Array.isArray(value) ? value.map(v => v.value) : value.value;
    }
  }
  return filtersObj;
}
export const mapFiltersToObjectFirstValueOnly = (table: Table): { [key: string]: any } => {
  let filtersObj: { [key: string]: any } = {};
  for (const [key, value] of Object.entries(table.filters)) {
    if (isFilterApplied(key, value)) {
      filtersObj[key] = Array.isArray(value) ? value[0].value : value.value;
    }
  }
  return filtersObj;
}





/**
 * Recursively find all invalid form controls in a given form group or form array.
 * This function will traverse all controls, including nested ones.
 *
 * @param formGroup The form group or form array to inspect.
 * @returns An object with the path to the invalid controls and their corresponding error messages.
 */
export function findInvalidControls(formGroup: FormGroup | FormArray): { [key: string]: any } {
  const invalidControls: { [key: string]: any } = {};

  const recursiveCheck = (formGroupOrArray: FormGroup | FormArray, parentPath: string = '') => {
    Object.keys(formGroupOrArray.controls).forEach(key => {
      const control = formGroupOrArray.get(key);
      const controlPath = parentPath ? `${parentPath}.${key}` : key;

      if (control instanceof FormGroup || control instanceof FormArray) {
        // Recursively check nested FormGroup or FormArray
        recursiveCheck(control, controlPath);
      } else if (control?.invalid) {
        // If the control is invalid, add its path and error details to the result
        invalidControls[controlPath] = control.errors;
      }
    });
  };

  recursiveCheck(formGroup);

  return invalidControls;
}


export function findInvalidControlsArray(formGroup: FormGroup | FormArray): AbstractControl[] {

  const invalidControls: AbstractControl[] = [];

  const recursiveCheck = (formGroupOrArray: FormGroup | FormArray) => {
    Object.keys(formGroupOrArray.controls).forEach(key => {
      const control = formGroupOrArray.get(key);
      if (control instanceof FormGroup || control instanceof FormArray) {
        // Recursively check nested FormGroup or FormArray
        recursiveCheck(control);
      } else if (control?.invalid) {
        // If the control is invalid, add its path and error details to the result
        invalidControls.push(control);
      }
    });
  };

  recursiveCheck(formGroup);

  return invalidControls;
}





export function elapsedTimeText(durSeconds: number): string {
  // HH:MM:SS
  const hours = Math.floor(durSeconds / 3600);
  const minutes = Math.floor((durSeconds % 3600) / 60);
  const seconds = durSeconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

export function elapsedTimeHumanText(durSeconds: number, full = false): string {
  // HH:MM:SS
  const hours = Math.floor(durSeconds / 3600);
  const minutes = Math.floor((durSeconds % 3600) / 60);
  const seconds = durSeconds % 60;
  if (full) {
    return `${hours} hours ${minutes} minutes ${seconds} seconds`;
  }
  else {
    if (hours > 0) {
      return `${hours} hours ${minutes} minutes ${seconds} seconds`;
    }

    if (minutes > 0) {
      return `${minutes} minutes ${seconds} seconds`;
    }

    return `${seconds} seconds`;
  }
}




// Helper interface for the result object
export interface InvalidControlDetails {
  control: FormControl;          // The actual form control
  nativeElement: HTMLElement;    // DOM element of the form control
  domIndex: number;              // Index of the element in the DOM
  index?: number;                // Optional: index if part of a FormArray
}

// Function to find and sort invalid controls
export function findInvalidControlsAdvance(
  formGroup: FormGroup,
  elementRef: ElementRef
): { [path: string]: InvalidControlDetails } {

  const invalidControlsMap: { [path: string]: InvalidControlDetails } = {};
  let elementCount = 0; // To track the overall DOM index

  // Recursive function to traverse the FormGroup/FormArray
  function traverseControls(
    control: FormGroup | FormArray | FormControl | AbstractControl,
    path: string = '',
    parentElement?: HTMLElement
  ): void {
    // If it's a FormGroup, iterate through its controls
    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach(key => {
        const childControl = control.get(key);
        const newPath = path ? `${path}.${key}` : key; // Build new path
        traverseControls(childControl!, newPath, parentElement);
      });
    }

    // If it's a FormArray, iterate through the controls within the array
    else if (control instanceof FormArray) {
      control.controls.forEach((childControl, index) => {
        const newPath = `${path}[${index}]`; // Path for array element
        traverseControls(childControl, newPath, parentElement);
      });
    }

    // If it's a FormControl
    else if (control instanceof FormControl) {
      if (control.invalid) {
        // Try to find the form control DOM element using formControlName or formArrayName
        let nativeElement: HTMLElement | null = null;

        // If part of a FormGroup, try to match formControlName
        if (parentElement) {
          nativeElement = parentElement.querySelector(
            `[formControlName="${path.split('.').pop()}"]`
          ) as HTMLElement;
        }

        // If part of a FormArray, match formArrayName and the control index
        if (!nativeElement && parentElement) {
          nativeElement = parentElement.querySelector(
            `[formArrayName="${path.split('[')[0]}"] [formControlName="${path.split('.').pop()}"]`
          ) as HTMLElement;
        }

        // If nativeElement is not found, fallback to generic search
        if (!nativeElement && parentElement) {
          nativeElement = parentElement.querySelector(`[name="${path}"]`) as HTMLElement;
        }

        // Save the invalid control details if the element is found
        if (nativeElement) {
          // Add the control to the map along with its DOM index
          invalidControlsMap[path] = {
            control: control,
            nativeElement: nativeElement,
            domIndex: elementCount++, // Increment the DOM index for each element
          };
        }
      }
    }
  }

  // Start traversing from the root formGroup
  traverseControls(formGroup, '', elementRef.nativeElement);

  // Sort invalid controls by their DOM index
  const sortedInvalidControls = Object.keys(invalidControlsMap)
    .sort((a, b) => {
      return invalidControlsMap[a].domIndex - invalidControlsMap[b].domIndex;
    })
    .reduce((acc, key) => {
      acc[key] = invalidControlsMap[key];
      return acc;
    }, {} as { [path: string]: InvalidControlDetails });

  return sortedInvalidControls;
}


export function handleScrollWithPadding(container: HTMLElement, padding = 10) {
  // const padding = 10; // 10pt padding

  const onScroll = () => {
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;

    // Add padding if scrolling near the top
    if (scrollTop < padding) {
      container.scrollTop = padding;
    }

    // Add padding if scrolling near the bottom
    if (scrollTop + clientHeight + padding > scrollHeight) {
      container.scrollTop = scrollHeight - clientHeight - padding;
    }
  };
  // if (!container) {
  //   console.error('Container is not defined');
  //   throw new Error('Container is not defined');
  // }
  // Attach the scroll event listener
  container.addEventListener('scroll', onScroll);

  // Return the unsubscribe function to remove the event listener
  return () => {
    container.removeEventListener('scroll', onScroll);
  };
}


export function isJobFinishedForEngineer(job: any) {
  // if status == finished
  if (job?.status === STATIC_JOB_STATUSE_CODES.FINISHED) {
    if (job?.engineerSessionLatest?.returnTripEndedData) {
      return true;
    }
    else {
      return false;
    }
  } else if (job?.status === STATIC_JOB_STATUSE_CODES.COMPLETED) {
    return true;
  }
  else {
    return false;
  }
}


export function serverDateFormat(date: Date | moment.Moment): string {
  // YYYY-MM-DD
  return moment(date).format('YYYY-MM-DD');
}

export function serverDateTimeFormat(date: Date | moment.Moment): string {
  // YYYY-MM-DD HH:mm:ss
  return moment(date).format('YYYY-MM-DD HH:mm:ss');
}
export function serverDateTimeFormatTz(date: Date | moment.Moment): string {
  // YYYY-MM-DD HH:mm:ss z
  return moment(date).format('YYYY-MM-DD HH:mm:ss z');
}

export function serverTimeFormat(date: Date | moment.Moment): string {
  // HH:mm:ss
  return moment(date).format('HH:mm:ss');
}

export function generateBrightColors(n: number, seed: number | null = null): string[] {
  const colors: string[] = [];
  const goldenRatioConjugate = 0.618033988749895;
  let hue = seed !== null ? seed % 1 : Math.random(); // Seed-based random or regular random

  for (let i = 0; i < n; i++) {
    hue += goldenRatioConjugate;
    hue %= 1; // Keep hue in the range [0, 1]

    // Convert the hue to RGB and store the color in hex format
    const rgb = hsvToRgb(hue, 0.9, 0.95); // Increase saturation and value for brighter colors
    const hex = rgbToHex(rgb);
    colors.push(hex);
  }

  return colors;
}


export function generateDeepColors(n: number, seed: number | null = null): string[] {
  const colors: string[] = [];
  const goldenRatioConjugate = 0.618033988749895;
  let hue = seed !== null ? seed % 1 : Math.random(); // Seed-based random or regular random

  for (let i = 0; i < n; i++) {
    hue += goldenRatioConjugate;
    hue %= 1; // Keep hue in the range [0, 1]

    // Convert the hue to RGB and store the color in hex format
    const rgb = hsvToRgb(hue, 0.85, 0.6); // Increase saturation and decrease value for deeper colors
    const hex = rgbToHex(rgb);
    colors.push(hex);
  }

  return colors;
}



export function generateColors(n: number, seed: number | null = null): string[] {
  const colors: string[] = [];
  const goldenRatioConjugate = 0.618033988749895;
  let hue = seed !== null ? seed % 1 : Math.random(); // Seed-based random or regular random

  for (let i = 0; i < n; i++) {
    hue += goldenRatioConjugate;
    hue %= 1; // Keep hue in the range [0, 1]

    // Convert the hue to RGB and store the color in hex format
    const rgb = hsvToRgb(hue, 0.5, 0.95);
    const hex = rgbToHex(rgb);
    colors.push(hex);
  }

  return colors;
}

// Helper function to convert HSV to RGB
export function hsvToRgb(h: number, s: number, v: number): [number, number, number] {
  let r: number, g: number, b: number;
  const i = Math.floor(h * 6);
  const f = h * 6 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);

  switch (i % 6) {
    case 0: r = v, g = t, b = p; break;
    case 1: r = q, g = v, b = p; break;
    case 2: r = p, g = v, b = t; break;
    case 3: r = p, g = q, b = v; break;
    case 4: r = t, g = p, b = v; break;
    case 5: r = v, g = p, b = q; break;
    default: r = 0, g = 0, b = 0; break; // This line is just for safety
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

// Helper function to convert RGB to HEX
export function rgbToHex([r, g, b]: [number, number, number]): string {
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
}


export function canEngineerActOnThisJob(engg: any, job: any, _dbg: boolean = false): boolean {

  // return true; // testing
  if (_dbg) console.log('canEngineerActOnThisJob', { engg, job });

  if (!engg) {
    if (_dbg) console.log('cannot act on this job, engg is null');
    return false;
  }
  if (!job) {
    if (_dbg) console.log('cannot act on this job, job is null');
    return false;
  }


  if (!engg?.enggJobSessionLatest) {
    if (_dbg) console.log('can act on this job, no session yet');
    return true;
  }

  if (engg?.enggJobSessionLatest?.job == job._id) {
    if (_dbg) console.log('can act on this job');
    return true;
  }
  else {
    // console.log('cannot act on this job');
    if (_dbg) console.log('cannot act on this job');
    return engg?.enggJobSessionLatest?.returnTripEndedAt != null;
  }
}

export function QRCodeHelper(baseUrl: string, id: string): string {
  if (!baseUrl || !id) {
    throw new Error('Base URL and id are required to generate QR Code URL.');
  }
  return `${baseUrl}${id}`;
}

export function formatPhoneNumber(inputNumber: string | null) {
  if (!inputNumber) {
    return {
      number: null,
      internationalNumber: null,
      nationalNumber: null,
      e164Number: null,
      countryCode: null,
      dialCode: null,
    };
  }

  const dialCode = inputNumber.split(" ")[0];

  const countryEntry = countryCodeList.find(entry => entry.dialCode === dialCode);

  const countryCode = countryEntry ? countryEntry.countryCode : "Unknown";

  const e164Number = inputNumber.replace(/\s+/g, "");

  const nationalNumber = inputNumber.replace(dialCode, "").trim();

  const phoneDetails = {
    number: nationalNumber,
    internationalNumber: inputNumber,
    nationalNumber: nationalNumber,
    e164Number: e164Number,
    countryCode: countryCode,
    dialCode: dialCode,
  };

  console.log("new phone number", phoneDetails);
  return phoneDetails;
}


//Allow only alphabet
export function letterInput(event: KeyboardEvent) {
  const char = event.key;
  console.log('letterInput', { char });
  // allow spesial keys
  if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(char)) {
    console.log('allowing special key', char);
    return; // Allow backspace, delete, arrow keys, and tab
  }

  if (!/^[a-zA-Z\s]$/.test(char)) {
    event.preventDefault();

  }
}

//Allow both alphabet and numbers
export function lettersAndNumbersInput(event: KeyboardEvent) {
  const char = event.key;

  // allow spesial keys
  if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(char)) {
    return; // Allow backspace, delete, arrow keys, and tab
  }

  if (!/^[a-zA-Z0-9\s]$/.test(char)) {
    event.preventDefault();
  }
}

//Allow only numbers
export function numberInput(event: KeyboardEvent) {
  const char = event.key;

  // allow spesial keys
  if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(char)) {
    return; // Allow backspace, delete, arrow keys, and tab
  }

  if (!/^[0-9]$/.test(char)) {
    event.preventDefault();
  }
}




export type AvatarOptions = {
  background?: string; // Hex color without '#', or 'random'
  color?: string; // Text color, e.g. 'fff'
  rounded?: boolean; // true for rounded image
  size?: number; // Size in pixels
  format?: 'png' | 'svg'; // Image format
};

/**
 * Generates a UI Avatars URL based on a name and optional settings.
 * @param name - Full name of the person.
 * @param options - Optional avatar settings.
 * @returns A string URL to the generated avatar.
 */
export function getAvatarUrl(
  name: string,
  options: AvatarOptions | undefined = {
    // background: 'random',
    rounded: true,
  }
): string {
  const baseUrl = 'https://ui-avatars.com/api/';
  const params = new URLSearchParams();

  params.set('name', name);
  if (options?.background) params.set('background', options.background);
  if (options?.color) params.set('color', options.color);
  if (options?.rounded) params.set('rounded', 'true');
  if (options?.size) params.set('size', options.size.toString());
  if (options?.format) params.set('format', options.format);

  return `${baseUrl}?${params.toString()}`;
}




export function transformMinUser(users: any[]) {
  if (!users || !Array.isArray(users)) {
    return [];
  }

  return users.map((user: any) => {
    let name = [user.firstName, user.lastName].filter(Boolean).join(" ");
    return {
      _id: user._id,
      firstName: user.firstName,
      lastName: user.lastName,
      name: user.fullName ?? name,
      email: user.email,
      phone: user.phone,
      profileImg: user.profileImg,
      avatar: getAvatarUrl(user.fullName ?? name, {
        background: 'random',
      }),
      role: {
        _id: user.role_id?._id,
        name: user.role_id?.name,
        role_number: user.role_id?.role_number,
        role_type: user.role_id?.role_type,
      },
      createdAt: user.createdAt,
      updatedAt: user.updatedAt,
    };
  });
}


export function clearMsalBrowserCache(): void {
  const prefix = 'msal.';

  const clear = (storage: Storage) => {
    for (let i = storage.length - 1; i >= 0; i--) {
      const key = storage.key(i);
      if (key && key.startsWith(prefix)) {
        storage.removeItem(key);
      }
    }
  };

  // MSAL can use either, depending on cacheLocation
  clear(localStorage);
  clear(sessionStorage);

  // If you ever enabled storeAuthStateInCookie, clear the legacy cookies too
  ['msal.error', 'msal.error.description', 'msal.state', 'msal.interaction.status'].forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  });
}
